import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, vModelRadio as _vModelRadio, toDisplayString as _toDisplayString, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "sign_form_wrap wrap_840" }
const _hoisted_3 = { class: "tab_wrap" }
const _hoisted_4 = {
  key: 0,
  class: "join sign_form agree_form"
}
const _hoisted_5 = { class: "checkbox_wrap" }
const _hoisted_6 = { for: "agree_all" }
const _hoisted_7 = ["checked"]
const _hoisted_8 = { class: "checkbox_wrap" }
const _hoisted_9 = { for: "agree_01" }
const _hoisted_10 = ["checked"]
const _hoisted_11 = { class: "checkbox_wrap" }
const _hoisted_12 = { for: "agree_02" }
const _hoisted_13 = ["checked"]
const _hoisted_14 = { class: "btn_wrap _default _250" }
const _hoisted_15 = {
  key: 1,
  class: "join sign_form"
}
const _hoisted_16 = { class: "imp" }
const _hoisted_17 = {
  key: 0,
  class: "p_info"
}
const _hoisted_18 = { class: "imp" }
const _hoisted_19 = {
  key: 0,
  class: "p_info"
}
const _hoisted_20 = { class: "imp" }
const _hoisted_21 = {
  key: 0,
  class: "p_warn"
}
const _hoisted_22 = { class: "imp" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "imp" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  class: "p_warn"
}
const _hoisted_28 = { class: "imp checkbox_wrap" }
const _hoisted_29 = ["for"]
const _hoisted_30 = ["id", "value", "disabled"]
const _hoisted_31 = ["textContent"]
const _hoisted_32 = { class: "imp mail_wrap" }
const _hoisted_33 = { class: "select_tab_box" }
const _hoisted_34 = { class: "tab_option" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "imp phone_wrap" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "imp add_wrap" }
const _hoisted_41 = { class: "join_way_wrap checkbox_wrap" }
const _hoisted_42 = ["for"]
const _hoisted_43 = ["id", "value", "onClick"]
const _hoisted_44 = ["textContent"]
const _hoisted_45 = { class: "checkbox_wrap" }
const _hoisted_46 = { for: "agree" }
const _hoisted_47 = { class: "btn_wrap _default _500" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "btn_wrap _default wrap_500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass([$setup.state.step === 0 ? 'active' : ''])
          }, [...(_cache[31] || (_cache[31] = [
            _createElementVNode("span", { class: "round_num" }, "step 1", -1),
            _createTextVNode(" 이용약관동의 ", -1)
          ]))], 2),
          _createElementVNode("div", {
            class: _normalizeClass([$setup.state.step === 1 ? 'active' : ''])
          }, [...(_cache[32] || (_cache[32] = [
            _createElementVNode("span", { class: "round_num" }, "step 2", -1),
            _createTextVNode(" 회원가입 ", -1)
          ]))], 2),
          _createElementVNode("div", {
            class: _normalizeClass([$setup.state.step === 2 ? 'active' : ''])
          }, [...(_cache[33] || (_cache[33] = [
            _createElementVNode("span", { class: "round_num" }, "step 3", -1),
            _createTextVNode(" 회원가입완료 ", -1)
          ]))], 2)
        ]),
        ($setup.state.step === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "info" }, "회원가입약관 및 개인정보처리방침안내의 내용에 동의하셔야 회원가입 하실 수 있습니다.", -1)),
              _createElementVNode("ul", null, [
                _createElementVNode("li", _hoisted_5, [
                  _createElementVNode("label", _hoisted_6, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      name: "",
                      id: "agree_all",
                      checked: $setup.state.isAgreeAll,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {
                                        $setup.state.isAgreeJoin = !$setup.state.isAgreeAll;
                                        $setup.state.isAgreeTerms = !$setup.state.isAgreeAll;
                                        $setup.state.isAgreeAll = !$setup.state.isAgreeAll;
                                    })
                    }, null, 8, _hoisted_7),
                    _cache[34] || (_cache[34] = _createElementVNode("em", null, null, -1)),
                    _cache[35] || (_cache[35] = _createElementVNode("span", null, "전체 동의", -1))
                  ])
                ]),
                _createElementVNode("li", _hoisted_8, [
                  _cache[38] || (_cache[38] = _createStaticVNode("<div class=\"con_tit\" data-v-0a2baee1>회원가입약관 (필수)</div><div class=\"con_desc\" data-v-0a2baee1><div class=\"custom_scroll2\" data-v-0a2baee1> 제 1 조 (목적) <br data-v-0a2baee1> 본 약관(이하 &quot;약관&quot;)은 &#39;서울특별시립 다시함께상담센터&#39;(이하 &quot;다시함께상담센터&quot;)와 회원에 관한 제반사항을 규정함을 목적으로 합니다. <br data-v-0a2baee1><br data-v-0a2baee1> 제 2 조 (약관의 효력 등) <br data-v-0a2baee1> ① 약관은 공시하고 상대방이 동의함으로써 효력을 발생합니다. 본 약관의 공시는 &#39;서울특별시립 다시함께상담센터&#39; 홈페이지(http://gamsi.dasi.or.kr/)에 게시하는 방법으로 합니다. <br data-v-0a2baee1> ② &quot;다시함께상담센터&quot;는 약관의 규제에 관한 법률 등 관련법을 위배하지 않는 범위 내에서 약관을 개정할 수 있습니다. <br data-v-0a2baee1> ③ &quot;다시함께상담센터&quot;가 약관을 개정할 경우에는 시행일 및 개정사유를 명시하여 &quot;다시함께상담센터&quot; 홈페이지에 시행일 7일전까지 공지합니다. <br data-v-0a2baee1> ④ 제3항의 방법으로 변경 고지된 약관은 기존의 회원에게도 유효하게 적용됩니다. <br data-v-0a2baee1><br data-v-0a2baee1> 제 3 조 (약관의 해석 및 관할법원) <br data-v-0a2baee1> ① 약관에 정하지 아니한 사항과 이 약관의 해석에 관하여는 관계법령 및 상관례에 따릅니다. <br data-v-0a2baee1> ② 회원과 &quot;다시함께상담센터&quot; 사이에 분쟁이 발생할 경우에 관할 법원은 서울중앙지방법원으로 합니다. <br data-v-0a2baee1><br data-v-0a2baee1> 제 4 조 (용어의 정의) <br data-v-0a2baee1> &#39;회원&#39;은 &quot;다시함께상담센터&quot;에 개인정보를 제공하여 회원등록을 한 자로서, &quot;다시함께상담센터&quot;가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다. <br data-v-0a2baee1><br data-v-0a2baee1> 제 5 조 (회원 가입 및 자격) <br data-v-0a2baee1> ① &quot;다시함께상담센터&quot;가 정한 양식에 따라 회원정보를 기입한 후 회원가입을 신청함으로써 회원으로 등록됩니다. <br data-v-0a2baee1> ② 다음 각 호에 해당하는 경우에 &quot;다시함께상담센터&quot;는 회원 가입을 인정하지 않거나 회원 자격을 박탈할 수 있습니다. <br data-v-0a2baee1> 1. 다른 사람의 명의를 사용하여 가입 신청한 경우 <br data-v-0a2baee1> 2. 신청 시 필수 작성 사항을 허위로 기재한 경우 <br data-v-0a2baee1> 3. 관계법령의 위반을 목적으로 신청하거나 그러한 행위를 하는 경우 <br data-v-0a2baee1> 4. 사회의 안녕질서 또는 미풍양속을 저해할 목적으로 신청하거나 그러한 행위를 하는 경우 <br data-v-0a2baee1> 5. 다른 사람의 &quot;다시함께상담센터&quot;의 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우 <br data-v-0a2baee1> ③ &quot;다시함께상담센터&quot;가 회원 자격을 박탈하는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 사전 통지하여 소명할 기회를 부여합니다. <br data-v-0a2baee1><br data-v-0a2baee1> 제 6 조 (개인정보의 취득 및 이용) <br data-v-0a2baee1> ① &quot;다시함께상담센터&quot;는 개인정보 보호정책을 제정하여 시행하고, 개인 정보의 취득과 이용, 보호 등에 관한 법률을 준수합니다. 개인정보보호정책은 홈페이지 하단에 상시적으로 게시합니다. <br data-v-0a2baee1> ② &quot;다시함께상담센터&quot;는 고객이 제공하는 개인정보를 본 서비스 이외의 목적을 위하여 사용할 수 없습니다. <br data-v-0a2baee1> ③ &quot;다시함께상담센터&quot;는 고객이 제공한 개인정보를 고객의 사전 동의 없이 제 3자에게 제공할 수 없습니다. 단, 다음 각 호에 해당하는 경우에는 예외로 합니다. <br data-v-0a2baee1> 1. 전기통신기본법 등 관계법령에 의하여 국가기관의 요청에 의한 경우 <br data-v-0a2baee1> 2. 범죄에 대한 수사상의 목적이 있거나 정보통신윤리위원회의 요청이 있는 경우 <br data-v-0a2baee1> 3. 업무상 연락을 위하여 회원의 정보(성명, 주소, 전화번호)를 사용하는 경우 <br data-v-0a2baee1> 4. 홍보자료 또는 시장조사를 위하여 필요한 경우로서 특정 고객임을 식별할 수 없는 형태로 제공되는 경우 <br data-v-0a2baee1><br data-v-0a2baee1> 제 7 조 (회원 탈퇴) <br data-v-0a2baee1> ① 회원은 &quot;다시함께상담센터&quot;에 언제든지 탈퇴를 요청할 수 있으며 &quot;다시함께상담센터&quot;는 즉시 회원탈퇴를 처리합니다. <br data-v-0a2baee1> ② 회원이 &quot;다시함께상담센터&quot;에서 이용중인 서비스의 만기일이 지나지 않은 경우 &quot;다시함께상담센터&quot;는 탈퇴를 처리하지 않습니다. <br data-v-0a2baee1><br data-v-0a2baee1> 제 8 조 (회원에 대한 통지) <br data-v-0a2baee1> ① &quot;다시함께상담센터&quot;가 회원에 대한 통지를 하는 경우, 회원이 &quot;다시함께상담센터&quot;에 제출한 전자우편 주소, 휴대전화번호로 할 수 있습니다. <br data-v-0a2baee1> ② &quot;다시함께상담센터&quot;는 불특정다수 회원에 대한 통지의 경우 1주일 이상 &quot;다시함께상담센터&quot; 게시판에 게시함으로서 개별 통지에 갈음할 수 있습니다. <br data-v-0a2baee1><br data-v-0a2baee1> 제 9 조 (&quot;다시함께상담센터&quot;의 의무) <br data-v-0a2baee1> ① &quot;다시함께상담센터&quot;는 본 약관이 정하는 바에 따라 지속적이고 안정적인 서비스를 제공하는데 최선을 다합니다. <br data-v-0a2baee1> ② &quot;다시함께상담센터&quot;는 항상 등록자의 정보를 포함한 개인신상정보에 대하여 관리적, 기술적 안전조치를 강구하여 정보보안에 최선을 다합니다. <br data-v-0a2baee1> ③ &quot;다시함께상담센터&quot;는 공정하고 건전한 운영을 통하여 전자상거래 질서유지에 최선을 다하고 지속적인 연구개발을 통하여 양질의 서비스를 제공함으로써 고객만족을 극대화하여 인터넷 사업 발전에 기여합니다. <br data-v-0a2baee1> ④ &quot;다시함께상담센터&quot;는 고객으로부터 제기되는 불편사항 및 문제에 대해 정당하다고 판단될 경우 우선적으로 그 문제를 즉시 처리합니다. 단, 신속한 처리가 곤란할 경우, 고객에게 그 사유와 처리일정을 즉시 통보합니다. <br data-v-0a2baee1> ⑤ &quot;다시함께상담센터&quot;는 소비자 보호단체 및 공공기관의 소비자 보호업무의 추진에 필요한 자료 등의 요구에 적극 협력합니다. <br data-v-0a2baee1><br data-v-0a2baee1> 제 10 조 (회원의 의무) <br data-v-0a2baee1> ① ID와 비밀번호에 관한 모든 관리의 책임은 회원에게 있습니다. <br data-v-0a2baee1> ② 회원은 ID와 비밀번호를 제 3 자가 알 수 있도록 해서는 안 됩니다. <br data-v-0a2baee1> ③ 회원은 본 약관 및 관계법령에서 규정한 사항을 준수합니다. <br data-v-0a2baee1></div></div>", 2)),
                  _createElementVNode("label", _hoisted_9, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      name: "",
                      id: "agree_01",
                      checked: $setup.state.isAgreeJoin,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.state.isAgreeJoin = !$setup.state.isAgreeJoin))
                    }, null, 8, _hoisted_10),
                    _cache[36] || (_cache[36] = _createElementVNode("em", null, null, -1)),
                    _cache[37] || (_cache[37] = _createElementVNode("span", null, "회원가입약관의 내용에 동의합니다.", -1))
                  ])
                ]),
                _createElementVNode("li", _hoisted_11, [
                  _cache[41] || (_cache[41] = _createElementVNode("div", { class: "con_tit" }, "개인정보처리방침 안내 (필수)", -1)),
                  _cache[42] || (_cache[42] = _createElementVNode("div", { class: "con_desc" }, [
                    _createElementVNode("div", { class: "custom_scroll2" }, [
                      _createTextVNode(" 서울특별시립 다시함께상담센터는 「개인정보보호법」을 준수하며 개인정보 보호에 최선을 다하고 있습니다. "),
                      _createElementVNode("br"),
                      _createElementVNode("br"),
                      _createTextVNode(" 서울특별시립 다시함께상담센터는 시민이 필요로 하는 맞춤형 행정정보를 이메일, 휴대폰 문자(SMS) 등을 이용하여 빠르게 전달하고자 최소한의 개인정보를 수집하고 있으며 이를 위하여 ‘개인정보 제공 및 활용에 대한 동의’를 구하고 있습니다. "),
                      _createElementVNode("br"),
                      _createElementVNode("br"),
                      _createTextVNode(" 수집된 개인정보는 행사, 이벤트, 생활 정보, 센터 소식, 만족도 조사, 설문조사를 알려드리는 데에만 활용되며 일체 타 업무 목적으로는 활용되지 않습니다. 또한, 체계적이고 안전한 개인정보 보호 및 관리를 약속드립니다. "),
                      _createElementVNode("br"),
                      _createElementVNode("br"),
                      _createTextVNode(" ① 수집목적 : 행사, 이벤트, 생활 정보, 센터 소식, 만족도 조사, 설문조사, 물품 배송 ② 수집내용 : 필수항목(ID, 성명, 연락처, 생년월일, 성별, 주소(우편번호), 이메일주소), 선택항목(직업, 가입경로) ③ 보유기간 : 회원가입 날짜로부터 2년(단, 개인정보 삭제 요청 시 즉시 삭제) "),
                      _createElementVNode("br"),
                      _createElementVNode("br"),
                      _createTextVNode(" 서울특별시립 다시함께상담센터 ")
                    ])
                  ], -1)),
                  _createElementVNode("label", _hoisted_12, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      name: "",
                      id: "agree_02",
                      checked: $setup.state.isAgreeTerms,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.state.isAgreeTerms = !$setup.state.isAgreeTerms))
                    }, null, 8, _hoisted_13),
                    _cache[39] || (_cache[39] = _createElementVNode("em", null, null, -1)),
                    _cache[40] || (_cache[40] = _createElementVNode("span", null, "개인정보처리방침 안내 내용에 동의합니다.", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: "submit_btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.moveStep(1)))
                }, "다음")
              ])
            ]))
          : ($setup.state.step === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", _hoisted_16, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", {
                      for: "user_id",
                      class: "form_li_tit"
                    }, "아이디", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "user_id",
                      type: "text",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form_state.id) = $event)),
                      placeholder: "아이디를 입력하세요"
                    }, null, 512), [
                      [_vModelText, $setup.form_state.id]
                    ]),
                    _createElementVNode("button", {
                      class: "blue_btn",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.idExist && $setup.idExist(...args)))
                    }, "중복확인"),
                    (!$setup.state.idIsPossible)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_17, "영문자, 숫자, _만 입력 가능/ 최소 6자 이상 12자 이하로 입력하세요"))
                      : _createCommentVNode("", true)
                  ]),
                  ($setup.form_state.snsGubun === 1)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("li", _hoisted_18, [
                          _cache[45] || (_cache[45] = _createElementVNode("label", {
                            for: "user_pw",
                            class: "form_li_tit"
                          }, "비밀번호", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "user_pw",
                            type: "password",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.pw) = $event)),
                            placeholder: "비밀번호를 입력하세요"
                          }, null, 512), [
                            [_vModelText, $setup.state.pw]
                          ]),
                          (!$setup.state.pwIsPossible)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_19, "비밀번호는 문자, 숫자, 특수문자의 조합으로 8자 이상 입력해주세요."))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("li", _hoisted_20, [
                          _cache[46] || (_cache[46] = _createElementVNode("label", {
                            for: "user_pw_chk",
                            class: "form_li_tit"
                          }, "비밀번호 확인", -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "user_pw_chk",
                            type: "password",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.state.re_pw) = $event)),
                            placeholder: "비밀번호 확인"
                          }, null, 512), [
                            [_vModelText, $setup.state.re_pw]
                          ]),
                          (!$setup.state.pwReCheck)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_21, "*비밀번호가 일치하지 않습니다. 다시 입력해주세요."))
                            : _createCommentVNode("", true)
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_22, [
                    _cache[47] || (_cache[47] = _createElementVNode("label", {
                      for: "name",
                      class: "form_li_tit"
                    }, "이름", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "name",
                      type: "text",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form_state.name) = $event)),
                      placeholder: "이름을 입력하세요",
                      disabled: $setup.state.isPassOk
                    }, null, 8, _hoisted_23), [
                      [_vModelText, $setup.form_state.name]
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_24, [
                    _cache[48] || (_cache[48] = _createElementVNode("label", {
                      for: "nick",
                      class: "form_li_tit"
                    }, "닉네임", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "nick",
                      type: "text",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form_state.nickname) = $event)),
                      placeholder: "닉네임을 입력하세요"
                    }, null, 512), [
                      [_vModelText, $setup.form_state.nickname]
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_25, [
                    _cache[49] || (_cache[49] = _createElementVNode("label", {
                      for: "day",
                      class: "form_li_tit"
                    }, "생년월일", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "day",
                      type: "text",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form_state.birth) = $event)),
                      placeholder: "예: 20201212",
                      maxlength: "8",
                      disabled: $setup.state.isPassOk
                    }, null, 8, _hoisted_26), [
                      [_vModelText, $setup.form_state.birth]
                    ]),
                    (!$setup.state.birthIsPossible)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_27, "*생년월일이 올바르지 않습니다."))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", _hoisted_28, [
                    _cache[51] || (_cache[51] = _createElementVNode("span", { class: "form_li_tit" }, "성별", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.gender_list, (item, idx) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: idx,
                        for: item.id
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          id: item.id,
                          value: item.key,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.form_state.gender) = $event)),
                          name: "gender",
                          type: "radio",
                          disabled: $setup.state.isPassOk
                        }, null, 8, _hoisted_30), [
                          [_vModelRadio, $setup.form_state.gender]
                        ]),
                        _cache[50] || (_cache[50] = _createElementVNode("em", null, null, -1)),
                        _createElementVNode("span", {
                          textContent: _toDisplayString(item.value)
                        }, null, 8, _hoisted_31)
                      ], 8, _hoisted_29))
                    }), 128))
                  ]),
                  _createElementVNode("li", _hoisted_32, [
                    _cache[52] || (_cache[52] = _createElementVNode("label", {
                      for: "mail_01",
                      class: "form_li_tit"
                    }, "E-mail", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "mail_01",
                      type: "text",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.state.email) = $event)),
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, $setup.state.email]
                    ]),
                    _cache[53] || (_cache[53] = _createElementVNode("em", null, "@", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "mail_02",
                      type: "text",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.state.email_domain) = $event)),
                      placeholder: ""
                    }, null, 512), [
                      [_vModelText, $setup.state.email_domain]
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["selected_tab", [$setup.state.isActive ? 'active' : '']]),
                        onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.state.isActive = !$setup.state.isActive))
                      }, [
                        _createElementVNode("span", null, _toDisplayString($setup.state.select_domain), 1)
                      ], 2),
                      _createElementVNode("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.email_domain_list, (value, idx) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: idx,
                            onClick: ($event: any) => {
                                            $setup.state.email_domain = value;
                                            $setup.state.isActive = false;
                                            $setup.state.select_domain = value;
                                        },
                            class: _normalizeClass([$setup.state.email_domain === value ? 'active' : ''])
                          }, _toDisplayString(value), 11, _hoisted_35))
                        }), 128)),
                        _createElementVNode("button", {
                          class: "self",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => {
                                            $setup.state.email_domain = '';
                                            $setup.state.isActive = false;
                                            $setup.state.select_domain = '직접입력';
                                        })
                        }, " 직접입력 ")
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "blue_btn",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.emailExist($setup.form_state.email)))
                    }, "중복확인")
                  ]),
                  _createElementVNode("li", _hoisted_36, [
                    _cache[54] || (_cache[54] = _createElementVNode("label", {
                      for: "user_ph1",
                      class: "form_li_tit"
                    }, "전화번호", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "user_ph1",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.state.phone1) = $event)),
                      type: "text",
                      maxlength: "3",
                      disabled: $setup.state.isPassOk
                    }, null, 8, _hoisted_37), [
                      [_vModelText, $setup.state.phone1]
                    ]),
                    _cache[55] || (_cache[55] = _createElementVNode("em", null, "-", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "user_ph2",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.state.phone2) = $event)),
                      type: "text",
                      maxlength: "4",
                      disabled: $setup.state.isPassOk
                    }, null, 8, _hoisted_38), [
                      [_vModelText, $setup.state.phone2]
                    ]),
                    _cache[56] || (_cache[56] = _createElementVNode("em", null, "-", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "user_ph3",
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (($setup.state.phone3) = $event)),
                      type: "text",
                      maxlength: "4",
                      disabled: $setup.state.isPassOk
                    }, null, 8, _hoisted_39), [
                      [_vModelText, $setup.state.phone3]
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_40, [
                    _cache[57] || (_cache[57] = _createElementVNode("label", {
                      for: "zipCode",
                      class: "form_li_tit"
                    }, "주소", -1)),
                    _withDirectives(_createElementVNode("input", {
                      id: "zipCode",
                      type: "text",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (($setup.form_state.zip_code) = $event)),
                      readonly: "",
                      class: "code",
                      placeholder: "우편번호",
                      onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => ($setup.searchAddress && $setup.searchAddress(...args)))
                    }, null, 512), [
                      [_vModelText, $setup.form_state.zip_code]
                    ]),
                    _createElementVNode("button", {
                      id: "btnSearch",
                      class: "blue_btn",
                      onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => ($setup.searchAddress && $setup.searchAddress(...args)))
                    }, "검색"),
                    _withDirectives(_createElementVNode("input", {
                      id: "address",
                      type: "text",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.form_state.address) = $event)),
                      readonly: "",
                      class: "main_add",
                      placeholder: "기본주소"
                    }, null, 512), [
                      [_vModelText, $setup.form_state.address]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      id: "address_detail",
                      type: "text",
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (($setup.form_state.address_detail) = $event)),
                      placeholder: "상세주소"
                    }, null, 512), [
                      [_vModelText, $setup.form_state.address_detail]
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_41, [
                    _cache[59] || (_cache[59] = _createElementVNode("span", { class: "form_li_tit _full" }, "가입경로", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.location_list, (item) => {
                      return (_openBlock(), _createElementBlock("label", {
                        key: item.key,
                        for: 'join_way' + item.key
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          id: 'join_way' + item.key,
                          name: "join_way",
                          type: "radio",
                          value: item.key,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (($setup.form_state.location) = $event)),
                          onClick: ($event: any) => ($setup.toggleRadio(item.key))
                        }, null, 8, _hoisted_43), [
                          [_vModelRadio, $setup.form_state.location]
                        ]),
                        _cache[58] || (_cache[58] = _createElementVNode("em", null, null, -1)),
                        _createElementVNode("span", {
                          textContent: _toDisplayString(item.value)
                        }, null, 8, _hoisted_44),
                        (item.key === 5 && $setup.form_state.location === item.key)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.form_state.location_detail) = $event)),
                              placeholder: "예: 커뮤니티, 대학교 게시판"
                            }, null, 512)), [
                              [_vModelText, $setup.form_state.location_detail]
                            ])
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_42))
                    }), 128))
                  ]),
                  _createElementVNode("li", _hoisted_45, [
                    _cache[62] || (_cache[62] = _createElementVNode("span", { class: "form_li_tit _full" }, "원활한 활동 소식 안내를 위해 정보제공 수신 동의 부탁드립니다.", -1)),
                    _createElementVNode("label", _hoisted_46, [
                      _createElementVNode("input", {
                        id: "agree",
                        type: "checkbox",
                        onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.state.is_supply = !$setup.state.is_supply))
                      }),
                      _cache[60] || (_cache[60] = _createElementVNode("em", null, null, -1)),
                      _cache[61] || (_cache[61] = _createElementVNode("span", { class: "no_blue" }, "정보 메일을 받겠습니다. [선택]", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("button", {
                    class: "submit_btn _gray",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => ($setup.state.step = 0))
                  }, "취소"),
                  _createElementVNode("button", {
                    class: "submit_btn",
                    disabled: !$setup.state.isPossible,
                    onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => ($setup.join && $setup.join(...args)))
                  }, "회원가입", 8, _hoisted_48)
                ])
              ]))
            : ($setup.state.step === 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _cache[63] || (_cache[63] = _createStaticVNode("<div class=\"result_wrap wrap_500 join\" data-v-0a2baee1><div class=\"deco_wrap\" data-v-0a2baee1><span class=\"icon_wrap\" data-v-0a2baee1><img src=\"img/chk_big.png\" alt=\"\" data-v-0a2baee1></span><div class=\"main_bg_wrap\" data-v-0a2baee1><i class=\"deco_01 _small _blue\" data-v-0a2baee1><img src=\"img/bg_deco_03.png\" alt=\"\" data-v-0a2baee1></i><i class=\"deco_02 _small\" data-v-0a2baee1><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-0a2baee1></i><i class=\"deco_03 _small _green\" data-v-0a2baee1><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-0a2baee1></i><i class=\"deco_04 _small _green\" data-v-0a2baee1><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-0a2baee1></i><i class=\"deco_05 _small\" data-v-0a2baee1><img src=\"img/bg_deco_02.png\" alt=\"\" data-v-0a2baee1></i><i class=\"deco_06 _small\" data-v-0a2baee1><img src=\"img/bg_deco_02.png\" alt=\"\" data-v-0a2baee1></i></div></div><div class=\"con_wrap\" data-v-0a2baee1><p class=\"con_tit\" data-v-0a2baee1>회원가입이 완료되었습니다.</p><p data-v-0a2baee1> 반성매매 시민참여 플랫폼에서 진행하는 <br data-v-0a2baee1> 다양한 활동을 확인해보세요. </p></div></div>", 1)),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("button", {
                      class: "submit_btn",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => ($setup.router.replace('/')))
                    }, "홈으로")
                  ])
                ], 64))
              : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}